import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CoreConfigService } from '@core/services/config.service';
import { AuthService } from '../../services/auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-auth-account-activation',
  templateUrl: './auth-account-activation.component.html',
  styleUrls: ['./auth-account-activation.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AuthAccountActivationComponent implements OnInit {

  // Public
  public emailVar;
  public coreConfig: any;

  public submitted = false;

  // Private
  private _unsubscribeAll: Subject<any>;

  token: any;
  id: any;
  userToken: any;

  constructor(private _coreConfigService: CoreConfigService,
    private activatedRoute: ActivatedRoute,
    private _router: Router,
    private authService: AuthService) {
    this._unsubscribeAll = new Subject();

    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        customizer: false,
        enableLocalStorage: false
      }
    };
  }

  ngOnInit(): void {
    this.token = this.activatedRoute.snapshot.params.token;
    this.id = this.activatedRoute.snapshot.params.id;
    this.accountValidate();
    this.changeCerifiedStatus();

    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
  }

  accountValidate() {
    this.authService.accountActivate(this.token).subscribe((resp) => {
      localStorage.setItem('access_token', resp.access_token);
      this._router.navigate(['']);
    });
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  changeCerifiedStatus(){
    this.findByToken();
  }

  async findByToken(){
    this.authService.getUserToken(this.token).subscribe((resp) => {
      this.userToken = resp;

      if(this.userToken.verified == 0){
        this.updateVerifiedStatus(this.userToken.id);
      }
    });
  }

  updateVerifiedStatus(id: any) {
    this.authService.updateUser(id, { verified: 1 }).subscribe((resp) => {
    });
  }


}
